// const URL = "http://localhost:8888";
const URL = "https://qrbackend.hypertonic.co";

const WEBSITE = {
  login: "/api/v1/user/login",
  register: "/api/v1/user/register",
  category_view: "/api/category/view",
  product_view: "/api/product/view",
  menu_view: "/api/menu/view",
};

const ADMIN = {
  auth: "/api/v1/admin/auth",
  login: "/api/v1/admin/login",
  logout: "/api/v1/admin/logout",
  change_password: "/api/v1/admin/update-password",
  
  dashboard: "/api/v1/admin/dashboard",
  
  user_create: "/api/v1/admin/user/create",
  user_view: "/api/v1/admin/user/view",
  user_delete: "/api/v1/admin/user/delete",
  user_update: "/api/v1/admin/user/update",
  
  hotel_create: "/api/v1/admin/hotel/create",
  hotel_view: "/api/v1/admin/hotel/view",
  hotel_delete: "/api/v1/admin/hotel/delete",
  hotel_update: "/api/v1/admin/hotel/update",

  hotel_table_view: "/api/v1/admin/hotel/table",
  hotel_table_view_by_id: "/api/v1/admin/hotel/table/view",
  hotel_table_delete: "/api/v1/admin/hotel/table/delete",
  hotel_table_update: "/api/v1/admin/hotel/table/update",
  hotel_table_regenerate: "/api/v1/admin/hotel/table/regenerate",
  
  category_create: "/api/v1/admin/category/create",
  category_view: "/api/v1/admin/category/view",
  category_delete: "/api/v1/admin/category/delete",
  category_update: "/api/v1/admin/category/update",
  
  product_create: "/api/v1/admin/product/create",
  product_view: "/api/v1/admin/product/view",
  product_delete: "/api/v1/admin/product/delete",
  product_update: "/api/v1/admin/product/update",
  
  menu_create: "/api/v1/admin/menu/create",
  menu_view: "/api/v1/admin/menu/view",
  menu_delete: "/api/v1/admin/menu/delete",
  menu_update: "/api/v1/admin/menu/update",

};

const ADMIN_PREFIX = "/admin"; 

export { URL, ADMIN, WEBSITE, ADMIN_PREFIX };
